var forIn = function forIn(cb) {
  return function (obj) {
    Object.keys(obj).forEach(function (key) {
      return cb(obj[key], key, obj);
    });
  };
};

export default forIn;